import { render, staticRenderFns } from "./consulta.vue?vue&type=template&id=3db4b272&"
import script from "./consulta.vue?vue&type=script&lang=js&"
export * from "./consulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports